export default {
  title: 'Flower',
  apiUrl: process.env.VUE_APP_API_URL
}
